module.exports = __webpack_public_path__ + "static/media/piologo.bd3cd3ea.jpeg";